module.exports = __webpack_public_path__ + "static/media/cutsglare_french_00090.aee760aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/hdpolarized/axis/fr/cutsglare_french_00090.png
// module id = 1717
// module chunks = 0